import { BaseTabella } from '@lucan/base-ui'

export default function RisultatiLetturaDb(props) {
  const { risultati, ...restProps } = props
  const { nomeColonne, valori } = risultati

  const listaColonne = nomeColonne.map((valore) => ({
    accessor: valore,
    Header: valore.toUpperCase(),
  }))

  return (
    <BaseTabella
      columns={listaColonne}
      data={valori}
      righeColoriAlternati
      {...restProps}
    />
  )
}